/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 14/01/2025
 * @update 14/01/2025
 * @file src/components/W17/W17F2181
 */

import { Column } from "devextreme-react/data-grid";
import { Button, ButtonIcon, Checkbox, Col, DatePicker, Dropdown, Label, Popover, PopoverBody, Row, TextInput, Typography } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import * as userActions from "../../actions/user-actions";
import * as W17F2181Actions from "../../actions/w17/w17F2181/w17F2181-actions";
import Config from "../../config";
import GridContainer from "../common/grid-container/grid-container";
import { Loading } from "../common/loading/loading";
import EventTracking from "../common/tracking/event";

const FormID = 'W17F2181';
const dateColumnProps = {
    width: 150,
    dataType: 'date',
    alignment: 'center',
    format: 'dd/MM/yyyy',
    editorOptions: { placeholder: 'DD/MM/YYYY' }
};

const useStyles = makeStyles((theme) => ({
    popAction: {
        minWidth: 196,
        padding: theme.spacing([2, 0, 2, 0])
    },
    btnActionItem: {
        display: 'flex',
        width: '100%',
        justifyContent: 'start',
        color: theme.colors.primary
    },
    colGridLeft: {
        height: '100%',
        [theme.breakpoints.up('md')]: {
            borderRight: `1px solid ${theme?.colors?.line?.system}`,
        },
    },
    divScroll: {
        paddingRight: '1px',
        height: 'calc(100vh - 254px)',
        overflow: 'auto',
        [theme.breakpoints.down('md')]: {
            height: '100%',
            overflow: 'inherit',
        },
    },
    divBottom: {
        padding: theme.spacing(6),
        marginLeft: -theme.spacing(6),
        marginRight: '-15px',
        boxShadow: `0px -1px 0px ${theme?.colors?.line?.system}`,
        position: 'relative',
    },
}));

const initialDataMaster = {
    Disabled: 0,
    Title: '',
    Notes: '',
    JobsType: '',
    JobsTime: null,
    StartTime: null,
    EndTime: null,
};

const W17F2181 = (props) => {
    const { location } = props;
    const classes = useStyles();
    const [formLoading, setFormLoading] = useState(false);
    const [grid01Loading, setGrid01Loading] = useState(false);
    const [grid02Loading, setGrid02Loading] = useState(false);
    const [btnSaveStatus, setBtnSaveStatus] = useState(true); // Default disabled
    const [cboJobsTypeLoading, setCboJobsTypeLoading] = useState(false);
    const [cboStrCustomerLoading, setCboStrCustomerLoading] = useState(false);
    const [mode, setMode] = useState('view');
    const [error, setError] = useState({});
    const [dataCboJobsType, setDataCboJobsType] = useState([]);
    const [dataStrCustomer, setDataStrCustomer] = useState([]);

    const [dataMaster, setDataMaster] = useState(initialDataMaster);
    const [filterGrid01, setFilterGrid01] = useState({
        StrSearch: '',
    });
    const [filterGrid02, setFilterGrid02] = useState({
        StrCustomerID: '',
    });
    const [dataGrid01, setDataGrid01] = useState([]);
    const [dataGrid02, setDataGrid02] = useState([]);

    const grid01Ref = useRef(null);
    const grid02Ref = useRef(null);
    const gridContainerRef = useRef(null);
    const popMore01Ref = useRef(null);
    const currentGrid01RowClick = useRef({});

    const getInfo = (flag) => {
        const { Permission, EmployeeID = '' } = location?.state || {};
        if ((location && location.state) && !Config.isEmpty(EmployeeID)) {
            return {
                EmployeeID,
                Permission
            }
        } else {
            if (flag) {
                browserHistory.goBack();
                return null;
            }
            return false;
        }
    };

    useEffect(() => {
        if (!getInfo()) return;
        loadGrid(1);
        loadStrCustomer();
        getCboJobsType();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getCboJobsType = () => {
        setCboJobsTypeLoading(true);
        props.W17F2181Actions.getCboJobsType((error, data) => {
            setCboJobsTypeLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboJobsType(data);
            }
        });
    };

    const loadStrCustomer = () => {
        const { EmployeeID = '' } = currentGrid01RowClick.current;
        const params = {
            EmployeeID
        };
        setCboStrCustomerLoading(true);
        props.W17F2181Actions.loadStrCustomer(params, (error, data) => {
            setCboStrCustomerLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataStrCustomer(data || []);
            }
        });
    };

    const getDataSource = async (grid) => {
        let dataSource = [];
        if (grid === 1) {
            await grid01Ref.current.instance.saveEditData();
            dataSource = grid01Ref.current.instance.option('dataSource') || [];
        } else if (grid === 2) {
            await grid02Ref.current.instance.saveEditData();
            dataSource = grid02Ref.current.instance.option('dataSource') || [];
        }
        return dataSource;
    };

    const onSave = async () => {
        let CustomerIDArr = [];
        const dataSource = await getDataSource(2);
        for (let i = 0; i < dataSource.length; i++) {
            const { CustomerID = '', IsMultiple } = dataSource[i];
            if (!!IsMultiple) CustomerIDArr.push(CustomerID);
        }
        const { EmployeeID = '', RouteID = '' } = currentGrid01RowClick.current;
        const { Disabled = 0, StartTime = null, EndTime = null, JobsTime = null, Title = '', Notes = '', JobsType = '' } = dataMaster || {};
        const params = {
            Title,
            Notes,
            JobsType,
            StartTime,
            EndTime,
            JobsTime,
            Disabled,
            EmployeeID,
            RouteID,
            CustomerID: CustomerIDArr
        };
        setFormLoading(true);
        props.W17F2181Actions.onSave(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    handleActionSuccess(Config.lang('Luu'));
                } else {
                    if (data?.Message) Config.popupCore.show('INFO', data.Message);
                }
            }
        });
    };

    const loadGrid = (grid, dataRow = currentGrid01RowClick.current, isView = false) => {
        let DataType = '';
        let EmployeeID = '';
        let StrSearch = '';
        const { EmployeeID: employeeIDInfo = '' } = getInfo() || {};
        const { EmployeeID: employeeID = '', RouteID = '' } = dataRow || {};
        const { StrSearch: strSearch = '' } = filterGrid01;
        const { StrCustomerID = '' } = filterGrid02;
        if (grid === 1) {
            EmployeeID = employeeIDInfo;
            DataType = 'Loadgrid1';
            StrSearch = strSearch;
            setGrid01Loading(true);
        } else if (grid === 2) {
            DataType = isView ? 'Loadgrid2' : 'Loadgrid2_Edit';
            EmployeeID = employeeID;
            StrSearch = StrCustomerID;
            setGrid02Loading(true);
            setBtnSaveStatus(true); // Disable Btn Lưu
            setMode(isView ? 'view' : 'edit');
        }
        const params = {
            DataType,
            EmployeeID,
            StrSearch,
            RouteID
        };
        props.W17F2181Actions.loadGrid(params, (error, data) => {
            if (grid === 1) setGrid01Loading(false);
            if (grid === 2) setGrid02Loading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (grid === 1) {
                    setDataGrid01(data || []);
                    const currentPage = gridContainerRef.current.getRefPaging().instance.option('currentPage');
                    if (currentPage > 0) grid01Ref.current.instance.pageIndex(currentPage);
                }
                else if (grid === 2) {
                    loadStrCustomer();
                    setDataMaster(data?.[0] || {});
                    setDataGrid02(data || []);
                }
            }
        });
    };

    const handleActionSuccess = (label = '') => {
        currentGrid01RowClick.current = currentGrid01RowClick;
        loadGrid(1); // Load lại lưới 
        setDataGrid02([]); // Clear lưới 2
        setDataMaster(initialDataMaster); // set Rỗng
        setBtnSaveStatus(true); // Disabled Btn Lưu
        Config.popupCore.show('INFO', Config.lang(`%${label}%_thanh_cong`));
    };

    const onDelete = (data) => {
        const { EmployeeID = '', RouteID = '' } = data || {};
        const params = {
            EmployeeID,
            RouteID
        };
        setFormLoading(true);
        props.W17F2181Actions.onDelete(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    handleActionSuccess(Config.lang('Xoa'));
                } else {
                    if (data?.Message) Config.popupCore.show('INFO', data.Message);
                }
            }
        });
    };

    const onCancel = () => {
        setBtnSaveStatus(true); //
        setMode('view');
    };

    const renderCheckBoxColumn = (e, name = '') => {
        return <Checkbox
            readOnly={mode === 'view'}
            style={{ margin: 'auto' }}
            className={'display_row align-center'}
            checked={e?.value === 1}
            onChange={(c) => {
                e.component.cellValue(e.rowIndex, name, +c?.value);
                e.component.saveEditData();
                setBtnSaveStatus(false);
            }}
        />;
    };

    const onChange = (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        if (['JobsTime'].includes(fieldName) && Config.isEmpty(value)) value = null;
        switch (fieldName) {
            case 'StrSearch':
                setFilterGrid01({ ...filterGrid01, [fieldName]: value });
                setTimeout(() => loadGrid(1), 700);
                break;
            case 'StrCustomerID':
                setFilterGrid02({ ...filterGrid02, [fieldName]: value });
                break;
            default:
                setDataMaster({ ...dataMaster, [fieldName]: value });
                break;
        }
        setBtnSaveStatus(false); // enable btn Lưu
        if (error[fieldName] && !Config.isEmpty(value)) {
            setError({ ...error, [fieldName]: '' });
        }
    };

    const renderAction = (e, grid) => {
        const rowData = e?.data || {};
        const btnArr = [{
            label: Config.lang('Sua'),
            startIcon: 'Edit',
            onClick: () => {
                if (popMore01Ref.current) popMore01Ref.current.close();
                currentGrid01RowClick.current = rowData;
                loadGrid(2, rowData); // EDIT
            }
        },
        {
            label: Config.lang('Xoa'),
            startIcon: 'Delete',
            onClick: () => {
                if (popMore01Ref.current) popMore01Ref.current.close();
                onDelete(rowData);
            }
        }];
        return (
            <Popover {...(grid === 1 ? { ref: e => popMore01Ref.current = e } : {})}
                anchor={<ButtonIcon
                    viewType={'ghost'}
                    name={'Menu'}
                />}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}>
                <PopoverBody className={classes.popAction}>
                    {btnArr.map(item => (
                        <Button
                            viewType={'text'}
                            color={'info'}
                            labelProps={{ style: { textTransform: 'capitalize' } }}
                            className={classes.btnActionItem}
                            startIcon={item.startIcon}
                            label={item.label}
                            onClick={item.onClick}
                            disabled={!!item?.disabled}
                        />))}
                </PopoverBody>
            </Popover>
        );
    };

    const renderGrid01 = useMemo(() => {
        const dataSource = dataGrid01.map((item, idx) => ({ ...item, STT: idx }));
        return (
            <GridContainer
                reference={ref => (grid01Ref.current = ref)}
                ref={ref => (gridContainerRef.current = ref)}
                dataSource={dataSource}
                loading={grid01Loading}
                keyExpr={'STT'}
                typePaging={'normal'}
                itemPerPage={30}
                listPerPage={[30, 60, 90, 120]}
                height={Config.getHeightGrid() - 102}
                onCellClick={(e) => {
                    if (e.columnIndex === 0) return;
                    currentGrid01RowClick.current = { ...currentGrid01RowClick.current, ...e?.data };
                    loadGrid(2, currentGrid01RowClick.current, true); // View
                }}>
                <Column
                    cellRender={(e) => renderAction(e, 1)}
                    caption={Config.lang('Hanh_dong')}
                    alignment={'center'}
                    allowEditing={false}
                    allowSorting={false}
                    fixed={true}
                    width={100}
                />
                <Column
                    dataField={'Title'}
                    caption={Config.lang('Tieu_de')}
                    width={210}
                />
                <Column
                    dataField={'Notes'}
                    caption={Config.lang('Mo_ta')}
                    width={240}
                />
                <Column {...dateColumnProps}
                    dataField={'CreateDate'}
                    caption={Config.lang('Ngay_tao')}
                />
                <Column
                    dataField={'JobsType'}
                    caption={Config.lang('Loai')}
                    width={170}
                />
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGrid01, grid01Loading]);

    const renderGrid02 = useMemo(() => {
        const dataSource = dataGrid02.map((item, idx) => ({ ...item, STT: idx }));
        return (
            <GridContainer
                reference={ref => (grid02Ref.current = ref)}
                dataSource={dataSource}
                loading={grid02Loading}
                keyExpr={'STT'}
                typePaging={'normal'}
                itemPerPage={30}
                height={Config.getHeightGrid() - 420}
                editing={{
                    mode: 'cell',
                    refreshMode: 'reshape',
                    allowUpdating: mode === 'edit',
                    texts: { confirmDeleteMessage: '' },
                    startEditAction: 'click',
                }}
            >
                <Column
                    width={90}
                    allowEditing={false}
                    alignment={'center'}
                    dataField={'IsMultiple'}
                    caption={Config.lang('Chon')}
                    cellRender={(e) => renderCheckBoxColumn(e, 'IsMultiple')}
                />
                <Column
                    allowEditing={false}
                    dataField={'CustomerID'}
                    caption={Config.lang('Ma_khach_hang')}
                    width={160}
                />
                <Column
                    allowEditing={false}
                    dataField={'CustomerName'}
                    caption={Config.lang('Ten_khach_hang')}
                    width={240}
                />
                <Column
                    allowEditing={false}
                    dataField={'Adress'}
                    caption={Config.lang('Dia_chi')}
                    width={180}
                />
                <Column
                    allowEditing={false}
                    dataField={'Coordinates'}
                    caption={Config.lang('Toa_do')}
                    width={180}
                />
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGrid02, grid02Loading, mode]);

    if (!getInfo(true)) return null;
    return (
        <div className='page-container'>
            {formLoading && <Loading />}
            <EventTracking action={'FORM'} label={FormID} />
            <Row>
                <Col xs={12}><Typography color={'info'} type={'h4'}>{Config.lang('Danh_sach_tuyen')}</Typography></Col>
                <Col xs={12} sm={12} md={12} lg={4}>
                    <Row>
                        <Col xs={12} verticalAlign={'center'}>
                            <div className={'full_w display_row align-center'}>
                                <TextInput
                                    endIcon={'Search'}
                                    viewType={'outlined'}
                                    delayOnChange={700}
                                    className={'full_w'}
                                    value={filterGrid01.StrSearch}
                                    placeholder={Config.lang('Nhap_gia_tri_tim_kiem')}
                                    onChange={(e) => onChange('StrSearch', e)}
                                />
                            </div>
                        </Col>
                        <Col xs={12} className={`${classes.colGridLeft} mgt4x pdt0`}>{renderGrid01}</Col>
                    </Row>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8}>
                    <Row>
                        <Col xs={12} verticalAlign={'center'}>
                            <div className={'full_w display_row align-center'}>
                                <Typography hoverTooltip lineClamp={1} type={'h4'}>{Config.lang('Khach_hang')}</Typography>
                                <Dropdown
                                    clearAble
                                    className={'mgl4x'}
                                    viewType={'outlined'}
                                    valueExpr={'StrCustomerID'}
                                    displayExpr={'StrCustomerName'}
                                    loading={cboStrCustomerLoading}
                                    inputStyle={{ minWidth: 200 }}
                                    value={filterGrid02?.StrCustomerID}
                                    dataSource={dataStrCustomer || []}
                                    onChange={e => onChange('StrCustomerID', e)}
                                />
                                <Button
                                    color={'primary'}
                                    className={'mgl4x'}
                                    starIcon={'Search'}
                                    viewType={'outlined'}
                                    label={Config.lang('Tim_kiem')}
                                    onClick={() => loadGrid(2)}
                                />
                            </div>
                        </Col>
                        <Col xs={12} className={`${classes.divScroll} makeHaiLong`}>
                            <Row>
                                <Col xs={12}>{renderGrid02}</Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <TextInput
                                        label={Config.lang('Tieu_de')}
                                        viewType={'outlined'}
                                        value={dataMaster?.Title}
                                        onChange={(e) => onChange('Title', e)}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Dropdown
                                        clearAble
                                        viewType={'outlined'}
                                        valueExpr={'TaskType'}
                                        displayExpr={'TaskTypeName'}
                                        label={Config.lang('Loai_cong_viec')}
                                        loading={cboJobsTypeLoading}
                                        value={dataMaster?.JobsType}
                                        dataSource={dataCboJobsType || []}
                                        onChange={e => onChange('JobsType', e)}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <DatePicker
                                        clearAble
                                        useDateInput
                                        viewType={'outlined'}
                                        displayFormat={'DD/MM/YYYY'}
                                        label={Config.lang('Ngay_bat_dau')}
                                        max={dataMaster.EndTime}
                                        value={dataMaster.StartTime}
                                        onChange={e => onChange('StartTime', e)}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <DatePicker
                                        clearAble
                                        useDateInput
                                        viewType={'outlined'}
                                        displayFormat={'DD/MM/YYYY'}
                                        label={Config.lang('Ngay_ket_thuc')}
                                        min={dataMaster.StartTime}
                                        value={dataMaster.EndTime}
                                        onChange={e => onChange('EndTime', e)}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <TextInput
                                        multiline
                                        maxRows={5}
                                        viewType={'outlined'}
                                        value={dataMaster?.Notes}
                                        label={Config.lang('Mo_ta')}
                                        onChange={(e) => onChange('Notes', e)}
                                        error={error && error['Notes']}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6} verticalAlign={'center'}>
                                    <Checkbox
                                        label={Config.lang('Dong_tuyen')}
                                        checked={!!dataMaster?.Disabled}
                                        onChange={(e) => onChange('Disabled', e)}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12}>
                            <div className={`display_row align-between ${classes.divBottom}`}>
                                <div className={'display_row align-center'}>
                                    <Label type={'h4'}>{Config.lang('Ngay_phan_tuyen')}</Label>
                                    <DatePicker
                                        clearAble
                                        useDateInput
                                        className={'mgl4x'}
                                        viewType={'outlined'}
                                        displayFormat={"DD/MM/YYYY"}
                                        value={dataMaster?.JobsTime}
                                        onChange={e => onChange('JobsTime', e)}
                                    />
                                </div>
                                <div>
                                    <Button
                                        color={'danger'}
                                        viewType={'filled'}
                                        startIcon={'Cancel'}
                                        disabled={mode !== 'edit'}
                                        label={Config.lang('Huy')}
                                        onClick={() => onCancel()}
                                    />
                                    <Button
                                        color={'info'}
                                        viewType={'filled'}
                                        className={"mgl2x"}
                                        startIcon={'Save'}
                                        disabled={mode !== 'edit' || btnSaveStatus}
                                        label={Config.lang('Luu')}
                                        onClick={() => onSave()}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}

export default connect(() => null, (dispatch) => ({
    W17F2181Actions: bindActionCreators(W17F2181Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W17F2181);


